import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-of-studies',
  templateUrl: './board-of-studies.component.html',
  styleUrls: ['./board-of-studies.component.scss']
})
export class BoardOfStudiesComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
